import Swal from 'sweetalert2';

// Configuration par défaut pour SweetAlert2
const defaultConfig = {
  confirmButtonColor: '#2563eb',
  cancelButtonColor: '#6b7280',
  background: 'var(--swal-bg, #ffffff)',
  color: 'var(--swal-color, #1f2937)',
  customClass: {
    popup: 'swal2-popup-custom',
    title: 'swal2-title-custom',
    content: 'swal2-content-custom',
    confirmButton: 'swal2-confirm-custom',
    cancelButton: 'swal2-cancel-custom'
  }
};

// Service d'alertes personnalisées
export const alertService = {
  // Alerte de succès
  success: (title, text = '', options = {}) => {
    return Swal.fire({
      ...defaultConfig,
      icon: 'success',
      title,
      text,
      showConfirmButton: true,
      confirmButtonText: 'OK',
      timer: 3000,
      timerProgressBar: true,
      ...options
    });
  },

  // Alerte d'erreur
  error: (title, text = '', options = {}) => {
    return Swal.fire({
      ...defaultConfig,
      icon: 'error',
      title,
      text,
      showConfirmButton: true,
      confirmButtonText: 'OK',
      ...options
    });
  },

  // Alerte d'avertissement
  warning: (title, text = '', options = {}) => {
    return Swal.fire({
      ...defaultConfig,
      icon: 'warning',
      title,
      text,
      showConfirmButton: true,
      confirmButtonText: 'OK',
      ...options
    });
  },

  // Alerte d'information
  info: (title, text = '', options = {}) => {
    return Swal.fire({
      ...defaultConfig,
      icon: 'info',
      title,
      text,
      showConfirmButton: true,
      confirmButtonText: 'OK',
      ...options
    });
  },

  // Alerte de question
  question: (title, text = '', options = {}) => {
    return Swal.fire({
      ...defaultConfig,
      icon: 'question',
      title,
      text,
      showConfirmButton: true,
      confirmButtonText: 'OK',
      ...options
    });
  },

  // Confirmation simple
  confirm: (title, text = '', options = {}) => {
    return Swal.fire({
      ...defaultConfig,
      icon: 'question',
      title,
      text,
      showCancelButton: true,
      confirmButtonText: 'Confirmer',
      cancelButtonText: 'Annuler',
      reverseButtons: true,
      ...options
    });
  },

  // Confirmation de suppression
  confirmDelete: (title = 'Êtes-vous sûr ?', text = 'Cette action est irréversible !', options = {}) => {
    return Swal.fire({
      ...defaultConfig,
      icon: 'warning',
      title,
      text,
      showCancelButton: true,
      confirmButtonText: 'Oui, supprimer !',
      cancelButtonText: 'Annuler',
      confirmButtonColor: '#ef4444',
      reverseButtons: true,
      ...options
    });
  },

  // Confirmation de sauvegarde
  confirmSave: (title = 'Sauvegarder ?', text = 'Voulez-vous sauvegarder les modifications ?', options = {}) => {
    return Swal.fire({
      ...defaultConfig,
      icon: 'question',
      title,
      text,
      showCancelButton: true,
      confirmButtonText: 'Sauvegarder',
      cancelButtonText: 'Annuler',
      reverseButtons: true,
      ...options
    });
  },

  // Toast de succès
  toastSuccess: (title, options = {}) => {
    return Swal.fire({
      ...defaultConfig,
      toast: true,
      position: 'top-end',
      icon: 'success',
      title,
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      ...options
    });
  },

  // Toast d'erreur
  toastError: (title, options = {}) => {
    return Swal.fire({
      ...defaultConfig,
      toast: true,
      position: 'top-end',
      icon: 'error',
      title,
      showConfirmButton: false,
      timer: 4000,
      timerProgressBar: true,
      ...options
    });
  },

  // Toast d'information
  toastInfo: (title, options = {}) => {
    return Swal.fire({
      ...defaultConfig,
      toast: true,
      position: 'top-end',
      icon: 'info',
      title,
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      ...options
    });
  },

  // Modal de chargement
  loading: (title = 'Chargement...', text = 'Veuillez patienter', options = {}) => {
    return Swal.fire({
      ...defaultConfig,
      title,
      text,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
      ...options
    });
  },

  // Fermer toutes les alertes
  close: () => {
    Swal.close();
  },

  // Alerte personnalisée avec HTML
  custom: (options = {}) => {
    return Swal.fire({
      ...defaultConfig,
      ...options
    });
  },

  // Alerte de formulaire avec validation
  formAlert: (title, html, options = {}) => {
    return Swal.fire({
      ...defaultConfig,
      title,
      html,
      showCancelButton: true,
      confirmButtonText: 'Valider',
      cancelButtonText: 'Annuler',
      reverseButtons: true,
      preConfirm: () => {
        // Validation personnalisée peut être ajoutée ici
        return true;
      },
      ...options
    });
  }
};

// Hook personnalisé pour utiliser le service d'alertes
export const useAlert = () => {
  return alertService;
};

export default alertService;
